import { FinpayVobWebformElement } from './finpay-vob-webform.element';

const ELEMENT_TAG = 'finpay-vob-webform';

export function registerFinpayVobWebform(
  tagName: string = ELEMENT_TAG
): void {
  if (customElements.get(tagName)) {
    return;
  }
  customElements.define(tagName, FinpayVobWebformElement);
}

registerFinpayVobWebform();

export { FinpayVobWebformElement } from './finpay-vob-webform.element';
export type {
  VobWebformConfig,
  VobWebformPayor,
  VobWebformResult,
  VobWebformSubmitPayload,
} from './types';
